import type { ReactNode } from 'react'
import type { FootballCoreBrowserAdapter } from '~/lib/navigation/football-core'

import {
  navigateFootballCoreBack,
  resolveFootballCoreBack,
} from '~/lib/navigation/football-core'

interface FootballCoreBackProps {
  children: ReactNode
  className?: string
  explicitTarget?: string
  fallback: string
  locale: 'en' | 'zh-CN'
  browser?: FootballCoreBrowserAdapter
}

function currentBrowserAdapter(): FootballCoreBrowserAdapter {
  return {
    length: window.history.length,
    referrer: document.referrer,
    origin: window.location.origin,
    back: () => window.history.back(),
    assign: href => window.location.assign(href),
  }
}

export function FootballCoreBack({
  browser,
  children,
  className,
  explicitTarget,
  fallback,
  locale,
}: FootballCoreBackProps) {
  if (explicitTarget !== undefined) {
    const destination = resolveFootballCoreBack({
      explicitTarget,
      fallback,
      locale,
    })
    return (
      <a className={className} href={destination.kind === 'target' ? destination.href : fallback}>
        {children}
      </a>
    )
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => navigateFootballCoreBack(
        { fallback, locale },
        browser ?? currentBrowserAdapter(),
      )}
    >
      {children}
    </button>
  )
}
